// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

const actions = {
    getAllMetrics: ({commit}, payload) => {
      const ApiClient = payload.ApiClient;
      const departments = payload.departments;
      const dateFrom = payload.dateFrom;
      const dateTo = payload.dateTo;
      
      const params =  {
        firebaseIdToken: ApiClient.token,
        departments: departments,
        from: dateFrom,
        to: dateTo
      }
      console.log(params);
      return axios.get(
          process.env.VUE_APP_HOUR_APP_BACKEND + '/api/metrics',
          {
            params
          }
        ).then(res => {
          return res
        }).catch((err) => {
          return err
      });
    }
}

export default actions